import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc0c3ee8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parent" }
const _hoisted_2 = { class: "select-ct" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "使用项目", -1))
const _hoisted_4 = { class: "card-ct" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "  数  据  库：", -1))
const _hoisted_6 = { style: {"font-size":"16px","font-weight":"bold"} }
const _hoisted_7 = { style: {"margin-top":"10px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "  账        号：", -1))
const _hoisted_9 = { style: {"font-size":"16px","font-weight":"bold"} }
const _hoisted_10 = { style: {"margin-top":"10px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { style: {"color":"red"} }, "* ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "原始密码：", -1))
const _hoisted_13 = { style: {"margin-top":"10px"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { style: {"color":"red"} }, "* ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "新  密  码：", -1))
const _hoisted_16 = { style: {"margin-top":"10px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { style: {"color":"red"} }, "* ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "确认密码：", -1))
const _hoisted_19 = { class: "button-footer" }

import {useRoute} from "vue-router";
import {getListData, postData} from "@/service/main/system";
import {ElMessage} from "element-plus/es";
import {ElLoading, ElMessageBox} from 'element-plus'
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AllUpdate',
  setup(__props, { expose: __expose }) {

const route = useRoute()
const defaultInfo = ref({})
const closePage = () => {
  window.close()
}

const value = ref('')
const options = [
  {title: '运营辅助平台', value: '1'},
  {title: '微控平台', value: '2'},
  {title: '直播间', value: '3'},
  {title: '企业微信检查系统', value: '4'},
  {title: '与牛共舞', value: '5'}
]

const databaseList = ref()

const handleSelect = (item: any) => {
  getListData('/main/databaseConfig/getDatabaseByBelongType', {belongType: item}).then((result) => {
    databaseList.value = result
  })
}

let connectInterval: number | null = null
const confirmAndRestart = () => {
  if (value.value == '') {
    ElMessage({
      message: '请选择使用项目',
      type: 'warning',
      showClose: true
    })
    return
  } else {
    if (databaseList.value.length > 0) {
      for (let i = 0; i < databaseList.value.length; i++) {
        if (databaseList.value[i].originalPassword == undefined || databaseList.value[i].originalPassword == '' || databaseList.value[i].newPassword == undefined || databaseList.value[i].newPassword == '' || databaseList.value[i].againPassword == undefined || databaseList.value[i].againPassword == '') {
          ElMessage({
            message: '数据库：' + databaseList.value[i].environment + ' 原始密码、新密码和确认密码不能为空',
            type: 'error',
            showClose: true
          })
          return
        }

        if (databaseList.value[i].password !== databaseList.value[i].originalPassword) {
          ElMessage({
            message: '数据库：' + databaseList.value[i].environment + ' 原始密码错误',
            type: 'error',
            showClose: true
          })
          return
        }

        if (databaseList.value[i].newPassword != databaseList.value[i].againPassword) {
          ElMessage({
            message: '数据库：' + databaseList.value[i].environment + ' 两次输入密码不一致',
            type: 'error',
            showClose: true
          })
          return
        }
      }

      ElMessageBox.confirm('是否立即重启该项目， 重启过程中会对数据库进行连接测试，请注意测试结果！！！', '提示', {
        confirmButtonText: '立即重启',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const testDatabaseLoading = ElLoading.service({
          lock: true,
          text: '数据库连接测试中',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        postData('/main/databaseConfig/updatePwd', {jsonStr: encodeURIComponent(JSON.stringify(databaseList.value))}).then((result) => {
          testDatabaseLoading.close()
          if (result.includes('成功')) {
            ElMessage({
              message: result,
              type: 'success',
              showClose: true
            })

            setTimeout(() => {
              const restartLoading = ElLoading.service({
                lock: true,
                text: '项目重启中，重启时间比较久，请耐心等待',
                background: 'rgba(0, 0, 0, 0.7)',
              })

              if (connectInterval) return
              connectInterval = setInterval(() => {
                console.log('尝试调用接口')
                getListData('/main/databaseConfig/getProjectStatus', {}).then((result) => {
                  if (result == '启动成功') {
                    stopTestConnect()
                    restartLoading.close()
                    ElMessage({
                      message: '重启成功！！！',
                      type: 'success',
                      showClose: true
                    })
                    setTimeout(() => {
                      closePage()
                    }, 1000)
                  }
                })
              }, 20000)
              postData('/main/databaseConfig/restartProject', {})
            }, 1000)
          } else {
            ElMessage({
              message: result,
              type: 'error',
              showClose: true
            })
            return
          }
        })
      })
    }
  }
}

function stopTestConnect() {
  if (connectInterval) {
    clearInterval(connectInterval)
    connectInterval = null
  }
}

// 清理定时器
__expose({stopTestConnect})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_select, {
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        placeholder: "请选择项目",
        style: {"width":"200px","margin-left":"20px","margin-top":"30px"},
        clearable: true,
        onChange: handleSelect
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
            return _createVNode(_component_el_option, {
              key: item.value,
              label: item.title,
              value: item.value,
              disabled: item.disabled
            }, null, 8, ["label", "value", "disabled"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(databaseList.value, (db) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          key: db.id,
          style: {"width":"25%","margin":"20px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_5,
              _createTextVNode(),
              _createElementVNode("span", _hoisted_6, _toDisplayString(db.environment), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(),
              _createElementVNode("span", _hoisted_9, _toDisplayString(db.username), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createVNode(_component_el_input, {
                modelValue: db.originalPassword,
                "onUpdate:modelValue": ($event: any) => ((db.originalPassword) = $event),
                style: {"width":"160px"},
                type: "password"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15,
              _createVNode(_component_el_input, {
                modelValue: db.newPassword,
                "onUpdate:modelValue": ($event: any) => ((db.newPassword) = $event),
                style: {"width":"160px"},
                type: "password"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _hoisted_18,
              _createVNode(_component_el_input, {
                modelValue: db.againPassword,
                "onUpdate:modelValue": ($event: any) => ((db.againPassword) = $event),
                style: {"width":"160px"},
                type: "password"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_el_button, { onClick: closePage }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        style: {"margin-left":"20px"},
        type: "primary",
        onClick: confirmAndRestart
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认并重启")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})